module.exports = __webpack_public_path__ + "img/mnclogo2.2ec543d9.png";